const useSetLanguage = (langCode: string): void => {
  const switchLocalePath = useSwitchLocalePath()

  useRouter().replace(switchLocalePath(langCode))
}

export default useSetLanguage
